import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchTaxrate } from '../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import ViewTaxrate from '../components/taxrate/ViewTaxrate';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  taxrates: PropTypes.object,
  params: PropTypes.object,
  error: PropTypes.any,
};

class TaxrateViewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertOpen: false,
      alertMessage: '',
      edited: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
  }
  componentDidMount() {
    this.props.dispatch(fetchTaxrate(this.props.params.zipcode));
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="taxrate component" style={authPage}>
        <h2>View Tax Rate</h2>
        <div className="content">
          <ViewTaxrate
            taxrate={this.props.taxrates.taxrate}
          />
        </div>
      </div>
    );
  }
}

TaxrateViewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

TaxrateViewPage.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    taxrates: state.taxrates,
  };
}

export default withRouter(connect(mapStateToProps)(TaxrateViewPage));



// WEBPACK FOOTER //
// ./src/containers/TaxrateViewPage.js